import { ManagementOverviewBanner } from '@contentManagement/types';
import { api } from '@services/api';

const bannersApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getManagementOverviewBanner: builder.query<ManagementOverviewBanner, void>({
            query: () => 'management/banners/overview-banner/',
            providesTags: ['ManagementOverviewBanner'],
        }),
        patchManagementOverviewBanner: builder.mutation<
            ManagementOverviewBanner,
            Partial<Omit<ManagementOverviewBanner, 'id' | 'image'>>
        >({
            query: (data) => ({
                url: 'management/banners/overview-banner/',
                method: 'PATCH',
                body: data,
            }),
            invalidatesTags: ['ManagementOverviewBanner'],
        }),
        postManagementOverviewBannerImage: builder.mutation<ManagementOverviewBanner, FormData>({
            query: (formData) => ({
                url: 'management/banners/overview-banner/image/',
                method: 'POST',
                body: formData,
            }),
            invalidatesTags: ['ManagementOverviewBanner'],
        }),
        deleteManagementOverviewBannerImage: builder.mutation<void, void>({
            query: () => ({
                url: 'management/banners/overview-banner/image/',
                method: 'DELETE',
            }),
            invalidatesTags: ['ManagementOverviewBanner'],
        }),
    }),
});
export const {
    useGetManagementOverviewBannerQuery,
    usePatchManagementOverviewBannerMutation,
    usePostManagementOverviewBannerImageMutation,
    useDeleteManagementOverviewBannerImageMutation,
} = bannersApi;
export default bannersApi;
